import translationsData from '../translations.json';
import { TranslationData, Language } from '../types';

export function useTranslation() {
  const translations = translationsData as TranslationData;

  // Translation function that takes a key and language
  const t = (key: string, lang?: Language): string => {
    const language = lang || 'en';
    const keys = key.split('.');
    let value: any = translations.ui[language];

    for (const k of keys) {
      value = value?.[k];
    }

    return value || key;
  };

  return {
    translations,
    t,
  };
}